import { createQueryKeys } from '@lukemorales/query-key-factory';
import { ClassService } from './service';
export const classQueries = createQueryKeys('classes', {
    listClasses: (classHashIds) => ({
        queryKey: [classHashIds],
        queryFn: () => ClassService.getClasses(classHashIds)
    })
});
